export class ActionTypeIsNotSupportedError extends Error {
  constructor(message?: any) {
    super(message);
    this.name = 'ActionTypeIsNotSupportedError';
  }
}
